import React from "react"
import PropTypes from "prop-types"
import { ExperienceOption } from "./ExperienceOption"

export const ExperienceDropdown = ({ dropdownOptions, experienceOptions, form }) => {
  return (
    <div style={{ padding: 0 }}>
      {dropdownOptions.map((option) => (
        <ExperienceOption key={option.value} option={option} experienceOptions={experienceOptions} form={form} />
      ))}
    </div>
  )
}

ExperienceDropdown.propTypes = {
  dropdownOptions: PropTypes.array.isRequired,
  experienceOptions: PropTypes.array,
  form: PropTypes.object.isRequired
}
